'use client';

import Button from '@enlighten/design-system/dist/Button';
import Stack from '@enlighten/design-system/dist/Stack';
import Link from 'next/link';

import { isServer } from '@/constants/common';
import { useOnChangeMessage } from '@/contexts/layouts/MessageProvider';

import { ZENDESK_LINK } from '../_constants';

const Section6Link = () => {
	const onChangeMessage = useOnChangeMessage();

	const handleCopyLink = async () => {
		if (isServer) {
			return;
		}

		const currentUrl = window.location.href;

		try {
			await navigator.clipboard.writeText(currentUrl);

			onChangeMessage({
				type: 'success',
				message: '링크를 복사하였습니다.',
			});
		} catch {
			onChangeMessage({
				type: 'error',
				message: '링크 복사에 실패했습니다. 다시 시도해 주세요.',
			});
		}
	};

	return (
		<Stack gap="16px" mt={{ xs: '24px', md: '40px' }}>
			<Button
				sx={{
					height: { xs: '52px', md: '60px' },
					backgroundColor: '#6400FF',
					color: '#FFFFFF',
					fontSize: { xs: '16px', md: '18px' },
					fontWeight: 700,

					'&:hover': {
						backgroundColor: '#0b49e2',
					},
				}}
				onClick={handleCopyLink}
			>
				링크 복사해서 공유하기
			</Button>
			<Button
				LinkComponent={Link}
				href={ZENDESK_LINK}
				target="_blank"
				variant="outlined"
				data-analytics="section6_apply_button"
				sx={{
					height: { xs: '52px', md: '60px' },
					fontSize: { xs: '16px', md: '18px' },
					fontWeight: 700,
					bgcolor: '#fff',
				}}
			>
				고객 발전소 대신 상담 신청하기 →
			</Button>
		</Stack>
	);
};

export default Section6Link;
